(() => {
  const storageKey = 'yomia_recent_products';

  const emit = (name, detail = {}) => {
    try {
      window.dispatchEvent(new CustomEvent(`yomia:${name}`, { detail }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: `yomia_${name}`, ...detail });
    } catch (_) {
      return;
    }
  };

  const parseRecent = () => {
    try {
      const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && typeof item.handle === 'string') : [];
    } catch (_) {
      return [];
    }
  };

  const saveRecent = (products) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(products.slice(0, 6)));
    } catch (_) {
      return;
    }
  };

  const createRecentCard = (item) => {
    const link = document.createElement('a');
    link.className = 'yomia-recent-card';
    link.href = typeof item.url === 'string' && item.url.startsWith('/') ? item.url : `/products/${item.handle}`;

    const media = document.createElement('div');
    media.className = 'yomia-recent-card__media';
    if (typeof item.image === 'string' && (item.image.startsWith('https://') || item.image.startsWith('//'))) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title || '';
      image.loading = 'lazy';
      image.width = 640;
      image.height = 800;
      media.append(image);
    }

    const title = document.createElement('strong');
    title.textContent = item.title || item.handle;
    const price = document.createElement('span');
    price.textContent = item.price || '';
    link.append(media, title, price);
    return link;
  };

  const initRecentlyViewed = () => {
    const root = document.querySelector('[data-yomia-recently-viewed]');
    if (!(root instanceof HTMLElement)) return;

    const current = {
      handle: root.dataset.productHandle || '',
      title: root.dataset.productTitle || '',
      url: root.dataset.productUrl || '',
      image: root.dataset.productImage || '',
      price: root.dataset.productPrice || '',
    };
    if (!current.handle) return;

    const previous = parseRecent().filter((item) => item.handle !== current.handle);
    const list = root.querySelector('[data-yomia-recent-list]');
    if (list instanceof HTMLElement && previous.length) {
      previous.slice(0, 4).forEach((item) => list.append(createRecentCard(item)));
      root.hidden = false;
    }
    saveRecent([current, ...previous]);
  };

  const initPassport = () => {
    document.querySelectorAll('[data-yomia-passport-trigger]').forEach((button) => {
      button.addEventListener('click', () => {
        const detailsSection = document.querySelector('[data-yomia-product-v3-details]');
        if (!(detailsSection instanceof HTMLElement)) return;
        detailsSection.querySelectorAll('.yomia-product-v3-accordion').forEach((details, index) => {
          if (details instanceof HTMLDetailsElement && (index === 0 || details.classList.contains('yomia-product-v3-accordion--crystal-meanings'))) {
            details.open = true;
          }
        });
        button.setAttribute('aria-expanded', 'true');
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        detailsSection.scrollIntoView({ behavior, block: 'start' });
        emit('passport_opened', { productHandle: document.querySelector('[data-yomia-product-handle]')?.dataset.yomiaProductHandle || '' });
      });
    });
  };

  const initEvents = () => {
    const productRoot = document.querySelector('[data-yomia-product-handle]');
    const productHandle = productRoot instanceof HTMLElement ? productRoot.dataset.yomiaProductHandle || '' : '';
    if (productHandle) emit('product_viewed', { productHandle });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const intention = target?.closest('[data-yomia-intention]');
      if (intention instanceof HTMLElement) emit('intention_clicked', { intention: intention.dataset.yomiaIntention || '', productHandle });

      const personalize = target?.closest('a[href*="personalize-your-garden"]');
      if (personalize) emit('personalize_cta_clicked', { source: location.pathname });
    });

    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (event.action !== 'add' || !event.promise) return;
      event.promise.then(({ detail }) => {
        if (!detail?.didError) emit('add_to_cart', { productId: detail?.productId || '', itemCount: detail?.itemCount || 0 });
      }).catch(() => {});
    });

    document.addEventListener('theme-drawer:open', (event) => {
      if (event.target instanceof Element && event.target.matches('#cart-drawer')) emit('cart_opened');
    }, true);
  };

  const init = () => {
    initRecentlyViewed();
    initPassport();
    initEvents();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
